export const isCellPhone = (cellphone) => /^09\d{9}$/.test(cellphone);